import React from 'react'
import MainCard from 'ui-component/cards/MainCard'

function Reports() {
    return (
        <MainCard title="Reports">Coming Soon... </MainCard>
    )
}

export default Reports